const request = {}

request.createRequest = function (notePhraseData) {
  return {
    sortNumber: notePhraseData.sortNumber,
    title: notePhraseData.title,
    body: notePhraseData.body
  }
}
export default { request }
